// держать в соответствии с src/node/repositories/offer-card/entities/extended_data/ExtendedDataSchema.ts

import { IBookingInfoLine } from 'shared/components/BookingInfo/types';
import { IPaymentSummarySchema } from 'shared/repositories/dailyrent/entities/payment_summary/PaymentSummarySchema';

export enum EActionType {
  /** Смотреть заявку на бронирование **/
  'BookingRequestView' = 'bookingRequestView',
  /** Возможность написать в чат **/
  'Chat' = 'chat',
  /** Возможность связаться напрямую **/
  'Contact' = 'contact',
  /** Бронирование **/
  'OtaBooking' = 'otaBooking',
  /** Проверка дат **/
  'OtaCheckDates' = 'otaCheckDates',
  /** Забронировать партнёрский объект **/
  'PartnerBooking' = 'partnerBooking',
  /** Проверка дат у партнёрского объекта **/
  'PartnerCheckDates' = 'partnerCheckDates',
}

export enum EOfferLabels {
  /** Мгновенное бронирование **/
  'InstantBooking' = 'instantBooking',
}

export type TLineSchemaWithDiscount = IBookingInfoLine & {
  originalPrice: string;
  discountPercent: string;
};

export type TPaymentSummaryWithDiscount = Omit<IPaymentSummarySchema, 'headLine'> & {
  headLine: TLineSchemaWithDiscount;
};
